import { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { useSelector, useDispatch } from 'react-redux';
import {
	fetchWorkOrderById,
	updateWorkOrder,
	createWorkOrder,
} from '../slices/workOrdersSlice';
import { useForm } from 'react-hook-form';

export default function Checklist({ onClose, selectDetails }) {
	const dispatch = useDispatch();
	const order = useSelector((state) => state.orders.selectedOrder);
	const orderDetails = useSelector((state) => state.orders.order);

	const workorderItems = useSelector((state) => state.workOrders.workOrders) || [];

	console.log('workOrders', workorderItems);
	console.log('orderDetails', orderDetails);
	console.log('selectDetails', selectDetails);

	useEffect(() => {
		const fetchData = async () => {
			await dispatch(fetchWorkOrderById(orderDetails?.workOrder?.id));
		};

		fetchData();
	}, [dispatch, orderDetails?.workOrder?.id]);

	// update work order
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const onSubmit = async (data) => {
		const workOrderData = {
			id: orderDetails?.workOrder?.id,
			description: data.desciption,
			done: false,
		};

		await dispatch(updateWorkOrder(workOrderData));
		await dispatch(fetchWorkOrderById(orderDetails?.workOrder?.id));
	};

	const handleCkeck = async (data) => {
		const workOrderData = {
			id: orderDetails?.workOrder?.id,
			done: data.done,
		};

		await dispatch(updateWorkOrder(workOrderData));
		await dispatch(fetchWorkOrderById(orderDetails.workOrder.id));
	};

	return (
		<div className="details-details-panel">
			<aside className="details-panel">
				<div className="details-number">
					<h1>Checklist</h1>
					<div className="block-left">
						{/* <h3 className="order-number-title">Order {order.reference}</h3> */}
						<p className="details-number-value">
							{/* Date {new Date(order.createdAt).toLocaleDateString()} */}
						</p>
					</div>
					<div className="block-right">
						<button onClick={onClose} className="close-btn">
							<X size={24} />
						</button>
					</div>
				</div>
				<div className="details-panel-content">
					<h2>
						<strong>Installer</strong> {orderDetails?.workOrder?.installerName}
					</h2>
					<hr />
					<h2>
						<strong>Checklist</strong>
					</h2>
					<form onSubmit={handleSubmit(onSubmit)}>
						<div className="w-full">
							<input
								type="text"
								{...register('desciption', { required: true })}
							/>
							<button type="submit">Add</button>
						</div>
					</form>

					<hr />
					{/* <form onSubmit={handleCkeck(onSubmit)}>
						{workorderItems?.map((item) => (
							<div key={item.id} className="flex justify-between">
								<p>{item.desciption}</p>
								<input type="checkbox" {...register('done')} />
							</div>
						))}
					</form> */}
				</div>
				{/* Name of the installer */}
				{/* Checklist display  */}
			</aside>
		</div>
	);
}
